// extracted by mini-css-extract-plugin
module.exports = {"container":"CreateSellNFTSection_container__Kolvf","title":"CreateSellNFTSection_title__L6MPJ"};